__turbopack_context__.v({
  "component": "style-module-scss-module__TZKoMG__component",
  "exp": "style-module-scss-module__TZKoMG__exp",
});
